import { render, staticRenderFns } from "./PageHero.vue?vue&type=template&id=7b67cb1e&scoped=true&"
import script from "./PageHero.vue?vue&type=script&lang=js&"
export * from "./PageHero.vue?vue&type=script&lang=js&"
import style0 from "./PageHero.vue?vue&type=style&index=0&id=7b67cb1e&scoped=true&lang=css&"
import style1 from "./PageHero.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b67cb1e",
  null
  
)

export default component.exports